<section
	[editableInStoryblok]="_editable"
	data-test-id="searchable-list-section"
>
	<div class="section-spacing">
		<div class="section-inner section-gap">
			<sb-columns [colOne]="titleInput()" component="columnOne" />
			<div class="flex flex-col gap-4 md:flex-row md:gap-6">
				<div class="w-full justify-start md:w-1/2">
					<vp-label
						[labelText]="'compositions.header.search' | translate"
						[position]="labelPosition"
						inputName="searchList"
					>
						<vp-input
							[placeholder]="
								'compositions.header.search' | translate
							"
							(emittedValue)="setSearchText($event)"
							icon="assets/icons/icon-looking-glass.svg"
							iconPosition="right"
							inputId="searchList"
							name="searchList"
							type="text"
						/>
					</vp-label>
				</div>
				<div class="w-full justify-end md:w-1/2">
					<vp-label
						[labelText]="'global.sort' | translate"
						[position]="labelPosition"
						inputName="sortList"
					>
						<vp-dropdown
							[centered]="true"
							[placeholder]="'global.sort-by' | translate"
							[selectData]="sortOptions()"
							[value]="'global.sort-by' | translate"
							(selectedValue)="sort($event)"
							data-test-id="sort-options-dropdown"
							inputId="sortList"
							variant="integrated"
						/>
					</vp-label>
				</div>
			</div>
			@if (useStoryblokCards()) {
				<ng-container
					[ngTemplateOutlet]="cardList"
					[ngTemplateOutletContext]="{
						items: orderedList(),
						useNgContent: true,
					}"
				/>
			}
		</div>
	</div>
</section>

<ng-template #cardList let-items="items" let-useNgContent="useNgContent">
	@for (item of items; track $index) {
		<vp-persuade-card
			[cardUrl]="item.ctaUrl"
			[ctaText]="item.ctaText"
			[ctaUrl]="item.ctaUrl"
			[headingType]="item.headingType"
			[images]="item.images || []"
			[pricingToolTip]="{
				occupancy: pricingTooltipOccupancy,
			}"
			[title]="item.title"
		>
			@if (useNgContent) {
				<ng-container content>
					@for (blok of item.content; track $index) {
						<ndc-dynamic
							[ndcDynamicComponent]="
								components[blok['component']]
							"
							[ndcDynamicInputs]="blok"
							class="hidden"
						/>
					}
				</ng-container>
			}
		</vp-persuade-card>
	}
</ng-template>
